import React from "react";
import { Card, CardBody, CardHeader, Container } from "reactstrap";
import Header from "../components/Headers/Header";

type Props = {};

const EAdhigamInfo = (props: Props) => {
  return (
    <>
      <Header />
      <Container>
        <Card className="mt--7 bg-white">
          <CardHeader>
            <h2>e-Adhigam Information</h2>
          </CardHeader>
          <CardBody>
            <Card style={{ border: "1px solid #33333330" }}>
              <CardHeader>
                <h4>Who is an e-Adhigam Student?</h4>
              </CardHeader>
              <CardBody>
                <p>
                  An e-Adhigam student is one who uses the tablet for 35 minutes per subject per week and attempts 2 tests (diagnostic test/remedial test/homework) per subject per week in any 3 subjects
                </p>
              </CardBody>
            </Card>
            <Card className="mt-4" style={{ border: "1px solid #33333330" }}>
              <CardHeader>
                <h4>Who is an e-Adhigam Teacher?</h4>
              </CardHeader>
              <CardBody>
                <p>
                  An e-Adhigam teacher is one who uses the tablet for 1 hour per week & assigns 2 personalized homeworks to students
                </p>
              </CardBody>
            </Card>
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default EAdhigamInfo;
